import api from 'app/gamma/src/api';

export interface MigrationResponse {
  aaExists: boolean;
  redirect_url: string;
  emailVerificationRequired?: boolean;
}

export class AtlassianAccountMigrationClient {
  static async migrate(): Promise<MigrationResponse | null> {
    try {
      const response = await api.client.rest.post<MigrationResponse>(
        `members/me/atlassianAccount/migrate`,
        {
          body: {
            // Show the "success overlay". See `AtlassianConfirmation.tsx`
            returnUrl: `${window.location.pathname}?onboarding=success`,
          },
        },
      );
      return response;
    } catch (err) {
      return null;
    }
  }
}
